/*
 * @Description: 全部照片 - 按人员 / 按标签 预约体验（b8059），groupID/role 从 store 实时读取，避免首屏未写入时误报
 */
import { store } from '../../../app/store'
import sensors, { sensorsRole } from '../../../utils/sensors'

export const B8059_REQUIREMENT_ID = 1011

export type B8059PopType = '按人员' | '按标签'

/** 与留资弹窗共用 workgroup_b8059_click，扩展按人员列表行为 */
export type B8059ClickItem =
  | 'clickEntry'
  | 'submit'
  | 'payAndSubmit'
  | 'noPayAndsubmit'
  /** 筛选栏「按人员」Switch 打开 */
  | 'openGroupByUser'
  /** 筛选栏「按人员」Switch 关闭 */
  | 'closeGroupByUser'
  /** 按人员聚合卡片「查看全部」跳转单成员列表 */
  | 'viewAllMemberPhotos'

const CLICK_TRACK_SIGN = 'aworkgroup.b8059.click.workgroup_b8059_click'
const EXPOSURE_TRACK_SIGN = 'aworkgroup.b8059.exposure.workgroup_b8059_exposure'

function readB8059Context(): { groupID: string; role: string } | null {
  const state = store.getState()
  const groupID = state.group.groupId
  const myRole = state.group.myRole
  const role = sensorsRole(myRole)
  if (!groupID || role === '') {
    return null
  }
  return { groupID: String(groupID), role }
}

/** 曝光/点击前可用于判断是否已具备团队与角色（sensorsRole 非空） */
export function isB8059TrackContextReady(): boolean {
  return readB8059Context() !== null
}

export function trackWorkgroupB8059Exposure(): void {
  const ctx = readB8059Context()
  if (!ctx) {
    return
  }

  sensors.track('workgroup_b8059_exposure', {
    requirement_id: B8059_REQUIREMENT_ID,
    track_sign: EXPOSURE_TRACK_SIGN,
    role: ctx.role,
    groupID: ctx.groupID
  })
}

export function trackWorkgroupB8059Click(params: {
  clickItem: B8059ClickItem
  popType: B8059PopType
  phoneNumber?: string
  /** viewAllMemberPhotos：成员 userID */
  string1?: string
}): void {
  const ctx = readB8059Context()
  if (!ctx) {
    return
  }

  const { clickItem, popType, phoneNumber, string1 } = params

  const payload: Record<string, string | number | boolean> = {
    requirement_id: B8059_REQUIREMENT_ID,
    track_sign: CLICK_TRACK_SIGN,
    clickItem,
    popType,
    role: ctx.role,
    groupID: ctx.groupID
  }

  if (phoneNumber !== undefined) {
    payload.phoneNumber = phoneNumber
  }
  if (string1 !== undefined && string1 !== '') {
    payload.string1 = string1
  }
  console.log('payload', payload)
  sensors.track('workgroup_b8059_click', payload)
}
